/*
 *
 * Preferences actions
 *
 */

import {
  DEFAULT_ACTION,
  ENABLE_LOADER,
  DISABLE_LOADER,
  GET_PREFERENCES_DATA,
  SET_ORDER_EXPIRY_TIME,
  SET_TRANSACTION_COMPLETE_TIME,
  INSTANT_REFUND_STATUS,
  UPDATE_DEFAULT_REFUND_SPEED,
  UPDATE_NOTIFICATION_GROUP,
} from './constants';

export function defaultAction() {
  return {
    type: DEFAULT_ACTION,
  };
}

export function enableLoaderAction() {
  return {
    type: ENABLE_LOADER,
  };
}

export function disableLoaderAction() {
  return {
    type: DISABLE_LOADER,
  };
}

export function getPreferencesDataAction(data) {
  return {
    type: GET_PREFERENCES_DATA,
    data,
  };
}

export function setOrderExpiryTimeAction(data) {
  return {
    type: SET_ORDER_EXPIRY_TIME,
    data,
  };
}

export function setTransactionCompleteTimeAction(data) {
  return {
    type: SET_TRANSACTION_COMPLETE_TIME,
    data,
  };
}

export function merchantIrConfigAction(data) {
  return {
    type: INSTANT_REFUND_STATUS,
    data,
  };
}

export function updateDefaultRefundSpeedAction(data) {
  return {
    type: UPDATE_DEFAULT_REFUND_SPEED,
    data,
  };
}

export function updateNotificationGroupAction(data) {
  return {
    type: UPDATE_NOTIFICATION_GROUP,
    data,
  };
}
